// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import InputField from './customFields/InputField';

const specialCharRegex = /^[a-zA-Z0-9\s.,'-]*$/;

const validateNoSpecialChars = (value) => {
  if (!value) return undefined;
  return specialCharRegex.test(value) ? undefined : 'Special characters are not allowed';
};

let AddOrEditCustomFieldsReduxForm = ({ handleSubmit, closeModal, submitting }) => (
  <Form onSubmit={handleSubmit}>
    <div className="popup_body">
      <div className="field_col">
        <label className="field_name" htmlFor="custom-field-name">
          Name
        </label>
        <Field
          id="custom-field-name"
          name="name"
          component={InputField}
          type="text"
          placeholder="Type here..."
          inputClassName="dashboard-input"
          paddingBottomClassName=""
          validate={validateNoSpecialChars}
        />
      </div>
    </div>

    <div className="popup_footer">
      <button
        type="button"
        className="dashboard-btn dashboard-btn--secondary"
        aria-label="cancel"
        onClick={closeModal}
      >
        Cancel
      </button>
      <button
        type="submit"
        className="dashboard-btn dashboard-btn--primary"
        aria-label="save"
        disabled={submitting}
      >
        Save
      </button>
    </div>
  </Form>
);

AddOrEditCustomFieldsReduxForm = reduxForm({
  form: 'addOrEditCustomFieldsReduxForm',
  enableReinitialize: true,
})(AddOrEditCustomFieldsReduxForm);

export default withRouter(AddOrEditCustomFieldsReduxForm);
